import $ from 'jquery';
// export for others scripts to use
window.jQuery = $;
window.jquery = $;
window.$ = $;
import whatInput from 'what-input';
import Foundation from 'foundation-sites';
import Leaflet from 'leaflet';
import Swiper, { Navigation, Pagination, Autoplay, Thumbs, EffectFade, } from 'swiper';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import mixitup from 'mixitup';
import 'cookie-consent.js';

// configure Swiper modules
Swiper.use([Navigation, Pagination, Autoplay, Thumbs, EffectFade]);


// General animations functions
// 
// -----------------------
function animateFrom(elem, direction) {
	direction = direction || 1;
	var x = 0,
		y = direction * 200;
		
	if(elem.classList.contains("gs_reveal_fromLeft")) {
		x = -200;
		y = 0;
	} else if (elem.classList.contains("gs_reveal_fromRight")) {
		x = 200;
		y = 0;
	}
	
	elem.style.transform = "translate(" + x + "px, " + y + "px)";
	elem.style.opacity = "0";
	
	gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
		duration: 1.25, 
		x: 0,
		y: 0, 
		autoAlpha: 1, 
		//ease: "expo", 
		overwrite: "auto"
	});
}
  
function hide(elem) {
	gsap.set(elem, {autoAlpha: 0});
}


document.addEventListener('DOMContentLoaded', function(event) {
	
	// Preloader
	// 
	// -----------------------
	var preloader = document.getElementById("preloader");
	if (preloader){
		window.addEventListener('load', function(event){			
			jQuery(preloader).fadeOut(300);
		})
	}
	
	// Load Zurb Foundation
	// 
	// -----------------------
	jQuery(document).foundation();


	// Load GSAP modules
	// 
	// -----------------------
	gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, MorphSVGPlugin);
	

	// General animations
	// 
	// -----------------------
	gsap.utils.toArray(".gs_reveal").forEach(function(elem) {
		hide(elem); // assure that the element is hidden when scrolled into view
		
		ScrollTrigger.create({
			trigger: elem,
			onEnter: function() { animateFrom(elem) }, 
			onEnterBack: function() { animateFrom(elem, -1) },
			onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
		});
	});
  
	// Header
	// 
	// -----------------------

	// Menu Triggers & Active elements 
	const headerElements = {
		logo: 			 document.querySelector('.site-title'),
		menuToggle: 	 document.querySelector('.menu-toggle'),
		navigation: 	 document.querySelector('.main-navigation'),
		closeNavigation: document.querySelector('.main-navigation__close'),
	}
	
	headerElements.menuToggle.addEventListener('click', activationMenu, false);
	headerElements.closeNavigation.addEventListener('click', activationMenu, false);
	
	function activationMenu(){
		const singleHeaderElement = Object.keys(headerElements)
		for (let value of singleHeaderElement) {
			headerElements[value].classList.toggle('is-active');
		}
		document.body.classList.toggle('no-scroll');
	}

	// Navigation slider
	const navigationSlider = new Swiper('.main-navigation__slider', {
		slidesPerView: 1.5,
        spaceBetween: 7,
		navigation: {
			nextEl: ".main-navigation__slider-next",
			prevEl: ".main-navigation__slider-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	});

	// Blocks
	// 
	// -----------------------
	
	// Fullwidth slider
	const blockSlider = new Swiper('.block-slider', {
		loop: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
	});

	// Image text
	let	countriesPath = document.querySelectorAll('.country-path'),
		countriesMarker = document.querySelectorAll('.country-marker');

	if(countriesPath){
		countriesPath.forEach((countryPath) => {
	
			if (countryPath){
	
				gsap.from(countryPath, {
					scrollTrigger: {
						trigger: countryPath,
						start: "top center",
					},
					drawSVG: 0,
					duration: 2,
				});
			}
		});
	
		countriesMarker.forEach((countryMarker) => {
	
			if (countryMarker){
		
				gsap.from(countryMarker, { 
					scrollTrigger: {
						trigger: countryMarker,
						start: "top center",
					},
					scale: 4,
					opacity: 0,
					transformOrigin: "center center",
					duration: 1.5,
					delay: 0.5,
					ease: "bounce.out",
				});
			}
		});
	
	}

	// Featured races
	/*
	let featuredRaces 	= document.querySelector('.featured-races__races'),
		featureTitle	= document.querySelector('.featured-races__titles-wrapper'),
		intFrameWidth 	= window.innerWidth;

	if (featuredRaces && intFrameWidth > 1199 ){

		let featuredRacesWidth 	= featuredRaces.offsetWidth,
			value 				= featuredRacesWidth - intFrameWidth - 35;
		
		gsap.to(featuredRaces, { 
			scrollTrigger: {
				trigger: featuredRaces,
				start: "top 20%",
				//markers: true,
				scrub: true,
				pin: featuredRaces,
				toggleClass:  { 
					targets: featureTitle, 
					className: 'fixed'
				},
			},
			x: -value,
			ease: "power1.inOut"
		});
	}*/
	
	// Featured races
	const featuredRacesSlider = new Swiper('.featured-races__races', {
		slidesPerView: 1,
		navigation: {
			nextEl: ".featured-races__next",
			prevEl: ".featured-races__prev"
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 30
			},
		},
	});


	// Race results
	const swiperResults = new Swiper('.results__races-slider', {
		slidesPerView: 2,
        spaceBetween: 0,
		navigation: {
			nextEl: '.results__races-next',
			prevEl: '.results__races-prev',
		},
		breakpoints: {
			768: {
				slidesPerView: 4,
			},
			1200: {
				slidesPerView: 6,
			}
		}
	});
	
	// Shopify store link
	const swiperShopify = new Swiper('.shopify-store__content', {
		slidesPerView: 2.5,
		centeredSlides: true,
		loop: true,
        spaceBetween: 0,
		navigation: {
			nextEl: '.shopify-store__content-next',
			prevEl: '.shopify-store__content-prev',
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				centeredSlides: false,
			},
			1200: {
				slidesPerView: 5,
			}
		}
	});


	// Single race
	// 
	// -----------------------

	
	// Race header animation
	let	raceFullscreenDescriptionTitle 	= document.querySelectorAll(".race-basic-info__title"),
		raceFullscreenDescriptionDesc 	= document.querySelectorAll(".race-basic-info__description"),
		raceFullscreenCountry 			= document.querySelectorAll(".race-basic-info__country");

	if (raceFullscreenDescriptionTitle){

		gsap.to(raceFullscreenDescriptionTitle,{
            scrollTrigger: {
                trigger: raceFullscreenDescriptionTitle,
                start: "top 50%",
                end: "bottom 0",
                toggleActions: "restart pause reverse none",
                scrub: true,
				//markers: true,
            },
            y: 180,
            color: "#0a0a0a",
        });
    
        gsap.to(raceFullscreenDescriptionDesc,{
            scrollTrigger: {
                trigger: raceFullscreenDescriptionTitle,
                start: "top 50%",
                end: "bottom 0",
                toggleActions: "restart pause reverse none",
                scrub: true,
				//markers: true,
            },
            y: -120,
        });

		gsap.to(raceFullscreenCountry,{
            scrollTrigger: {
                trigger: ".country-path",
                start: "top center",
                toggleActions: "restart pause reverse none",
                scrub: true,
            },
            y: -120,
            //ease: "power2.in",
        });
	}

	// Race routes slider
	var raceRoutetext = new Swiper(".race-routes__text-slider", {
		slidesPerView: 2,
		watchSlidesProgress: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1200: {
				slidesPerView: 4,
			},
		}
	});
  
	var raceRouteimage = new Swiper(".race-routes__image-slider", {
		slidesPerView: 1,
		loop: true,
		effect: "fade",
		fadeEffect: {
			crossFade: false
		},
		thumbs: {
			swiper: raceRoutetext,
		},
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".race-routes__image-slider-next",
			prevEl: ".race-routes__image-slider-prev",
		},

		pagination: {
			el: ".race-routes__image-slider-pagination",
			clickable: true,
		},
	});

	// Race read more
	let readMoreButtons = document.getElementsByClassName('race-page__read-more');

	if(readMoreButtons){
		for(let i = 0; i < readMoreButtons.length; i++)
		{
			//Get the text container that is before the button.
			let readMoreContainer = readMoreButtons[i].previousElementSibling;

			//Remove the height that could have been given by a class, and return its orginal height.
			readMoreContainer.style.height = 'auto';
			

			if(readMoreContainer.clientHeight < 360)
			{
				//Remove the class that gives it some properties and remove the button.
				readMoreContainer.classList.remove('race-page__hidden-data');
				readMoreButtons[i].style.display = 'none';
			}

			else
			{
				//Add the class the property that has been deleted before.
				readMoreContainer.style.height = '360px';
				readMoreButtons[i].addEventListener('click', showContent, false);
			}
		}
	}

	function showContent(event) { 
		this.classList.toggle('is-active');
		let readMoreContainer = this.previousElementSibling;

		if( !readMoreContainer.classList.contains('is-active')){ 
			readMoreContainer.classList.add('is-active');
			readMoreContainer.style.height = 'auto';
			

			let height = readMoreContainer.clientHeight + 'px';
			readMoreContainer.style.height = '360px';

			setTimeout(function () {
				readMoreContainer.style.height = height;
			}, 0);

			this.textContent = 'Read less';
			// Refresh ScrollTrigger
			ScrollTrigger.refresh();
			console.log('Refresh (1)');
		}

		else { 
			readMoreContainer.style.height = '360px';

			readMoreContainer.addEventListener('transitionend', function () {
				readMoreContainer.classList.remove('is-active');
			}, { once: true });

			this.textContent = 'Read More';
			// Refresh ScrollTrigger
			ScrollTrigger.refresh();
			console.log('Refresh (2)');
		}
	}

	// Race gallery slider
	var raceRouteimage = new Swiper(".race-gallery__slider", {
		slidesPerView: 1,
		loop: true,

		autoplay: {
			delay: 4500,
			disableOnInteraction: false,
		},

		pagination: {
			el: ".race-gallery__slider-pagination",
			clickable: true,
		},
	});


	// Race gallery lightbox
	let raceGallery = document.querySelectorAll('.race-gallery__gallery'), i;
	for (i = 0; i < raceGallery.length; ++i) {
	  
	  lightGallery(raceGallery[i], {
			//selector: '.gallery-item .gallery-icon a',
			plugins: [lgZoom, lgThumbnail],
			speed: 500,
			thumbnail: true,
			selector: '.race-gallery__image',
		});
	}

	// Race testimonial slider
	var raceTestimonialInfo = new Swiper(".race-testimonials__user-info", {
		slidesPerView: 1,
		watchSlidesProgress: true,
		loop: true,
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".testimonial-button-next",
			prevEl: ".testimonial-button-prev",
		},
	});
	
	// Races finder
	// 
	// -----------------------
	
	// Collapse filter in mobile devices
	let racesLocationAccordion = document.querySelector('.races-location__filters-accordion');
	
	if (racesLocationAccordion && window.innerWidth > 1199){
		jQuery('.races-location__filters-accordion').foundation('down', jQuery('.races-location__filters-wrapper'));
	}
	

	// Coaches
	//
	// -----------------------

	let classExists = document.getElementsByClassName('container-mixitup').length > 0;

	if(classExists)
	{
		//Activate the filters.
		var mixer = mixitup('.container-mixitup');

		//Hides the filter, if no element matches it

		let continents = ['all', 'north_america', 'south_america', 'europe', 'africa', 'asia_pacific'];

		let continentsAvailable = new Array();

		let coaches = document.getElementsByClassName('coach');

		for(let i = 0; i < coaches.length; i++)
		{
			for(let j = 0; j < continents.length; j++)
			{
				if(coaches[i].classList.contains(continents[j]))
					continentsAvailable.push(continents[j]);
			}
		}

		let filters = document.getElementsByClassName('continent-filters');

		for(let i = 0; i < filters.length; i++)
		{
			for(let j = 0; j < continentsAvailable.length; j ++)
			{
				let filterClasses = filters[i].getAttribute('data-filter').substring(1);

				if(continentsAvailable.includes(filterClasses))
					filters[i].style.display = "block";

				else
					filters[i].style.display = "none";
			}
		}
	}
});